import { render, staticRenderFns } from "./CompassCompetitors.vue?vue&type=template&id=1f5b79ec&scoped=true&"
import script from "./CompassCompetitors.vue?vue&type=script&lang=ts&"
export * from "./CompassCompetitors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b79ec",
  null
  
)

export default component.exports